import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { useTranslation as t } from "../../hooks/useTranslation/index.js";
import { StampContainer as p, OffText as d } from "./style.js";
var a = /* @__PURE__ */ ((n) => (n.DISCOUNT_PERCENTAGE = "discount_percentage", n.DISCOUNT_FIXED = "discount_fixed", n.FREE_SHIPPING = "free_shipping", n.FREE = "free", n.PRICE = "price", n))(a || {});
const h = ({
  type: n = "discount_fixed",
  value: c = 0,
  className: o
}) => {
  const { t: e } = t("common"), s = {
    price: `${e("deal-card-coupon-stamp-price")} ${c}`,
    discount_percentage: `${c}% OFF`,
    discount_fixed: `${e("deal-card-coupon-stamp-price")} ${c} OFF`,
    free_shipping: `${e("deal-card-coupon-stamp-shipping")} ${e("deal-card-coupon-stamp-free")}`,
    free: e("deal-card-coupon-stamp-free")
  }[n];
  return /* @__PURE__ */ r("span", { className: o, children: s });
}, m = ({
  type: n = "discount_fixed",
  value: c = 0,
  className: o
}) => {
  const { t: e } = t("common");
  return {
    price: /* @__PURE__ */ r(p, { className: o, children: /* @__PURE__ */ i("span", { children: [
      e("deal-card-coupon-stamp-price"),
      c
    ] }) }),
    discount_percentage: /* @__PURE__ */ i(p, { className: o, children: [
      /* @__PURE__ */ i("span", { children: [
        c,
        "%"
      ] }),
      /* @__PURE__ */ r(d, { children: " OFF" })
    ] }),
    discount_fixed: /* @__PURE__ */ i(p, { className: o, children: [
      /* @__PURE__ */ i("span", { children: [
        e("deal-card-coupon-stamp-price"),
        c
      ] }),
      /* @__PURE__ */ r(d, { children: " OFF" })
    ] }),
    free_shipping: /* @__PURE__ */ i(p, { className: o, children: [
      /* @__PURE__ */ r("span", { style: { display: "block" }, children: e("deal-card-coupon-stamp-shipping") }),
      /* @__PURE__ */ r("span", { style: { display: "block" }, children: e("deal-card-coupon-stamp-free") })
    ] }),
    free: /* @__PURE__ */ r(p, { className: o, children: /* @__PURE__ */ r("span", { children: e("deal-card-coupon-stamp-free") }) })
  }[n];
};
export {
  m as CouponStamp,
  h as CouponStampText,
  a as StampType
};
